import { motion, type Variants } from "framer-motion";
import React from "react";
import { fadeUp, stagger } from "@/lib/motion";

type Props = {
  children: React.ReactNode;
  className?: string;
  variants?: Variants;
  staggerChildren?: number;
  delayChildren?: number;
  once?: boolean;
  amount?: number;
  as?: "div" | "section";
};

export function AnimatedSection({
  children,
  className,
  variants,
  staggerChildren = 0.08,
  delayChildren = 0,
  once = true,
  amount = 0.2,
  as = "div",
}: Props) {
  const Comp = as === "section" ? motion.section : motion.div;
  return (
    <Comp
      className={className}
      variants={variants ?? stagger(staggerChildren, delayChildren)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount }}
    >
      {children}
    </Comp>
  );
}

export function FadeUp({
  children,
  className,
  delay,
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  const variants: Variants = delay
    ? {
        hidden: fadeUp.hidden,
        visible: {
          ...(fadeUp.visible as object),
          transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1], delay },
        },
      }
    : fadeUp;
  return (
    <motion.div className={className} variants={variants}>
      {children}
    </motion.div>
  );
}
